import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/sidebar';

@Component({
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {

  	code = Code;
  	visibleSidebar1;
    visibleSidebar2;
    visibleSidebar3;
    visibleSidebar4;
    visibleSidebar5;
	headers: any[];
	parameters: any[];
	eventHeader: any[];
	eventValue: any[];
  	styleHeader: any[];
	styleValue: any[];
    constructor() {
        
    }

    ngOnInit() {
    	this.headers = [
	        {name : "名字"},
	        {name : "类型"},
	        {name : "默认"},
	        {name : "描述"}
	    ];
	    this.parameters = [
	        {name: "visible",type: "boolean",default: "false",des: "指定对话框的可见性。"},
	        {name: "position",type: "string",default: "left	",des: "指定边栏的位置，有效值是'左'和'右'。"},
	        {name: "fullScreen",type: "boolean",default: "false",des: "向头添加一个关闭图标来隐藏对话框。"},
	        {name: "appendTo",type: "any",default: "null",des: "ARGET元素附加对话框，有效值为'体'或局部NGTE。"},
	        {name: "style",type: "string",default: "null",des: "组件内联样式。"},
	        {name: "styleClass",type: "string",default: "null",des: "组件的行内样式。"},
	        {name: "blockScroll",type: "boolean",default: "false ",des: "当边栏处于活动状态时，是否阻止文档滚动。"},
	        {name: "baseZIndex",type: "number",default: "0",des: "用于分层的基ZQUAL值。"},
	        {name: "autoZIndex",type: "boolean",default: "true",des: "是否自动管理分层。"}
	    ];

	    this.eventHeader = [
	    	{name:"名字"},
	    	{name:"参数"},
	    	{name:"描述"}
	    ]

	    this.eventValue = [
	    	{name: "onShow",param: "事件：事件对象",event: "当对话框显示时调用回调。"},
	    	{name: "onHide",param: "事件：事件对象",event: "当对话框隐藏时调用回调。"}
	    ]

	    this.styleHeader = [
	    	{name : "名字"},
	        {name : "元素"}
	    ];

	    this.styleValue = [
	    	{name : "ui-sidebar",el :"容器元素。" },
	    	{name : "ui-sidebar-left",el :"左侧边栏的容器元素。" },
	    	{name : "ui-sidebar-right",el :"右侧边栏的容器元素。" },
	    	{name : "ui-sidebar-top",el :"顶部边栏的容器元素。" },
	    	{name : "ui-sidebar-bottom",el :"底部边栏的容器元素。" },
	    	{name : "ui-sidebar-full",el :"全屏侧栏的容器元素。" },
	    	{name : "ui-sidebar-active",el :"边栏可见时的容器元素。" },
	    	{name : "ui-sidebar-close",el :"关闭锚固元件" },
	    	{name : "ui-sidebar-sm",el :"小尺寸侧边栏" },
	    	{name : "ui-sidebar-md",el :"中等尺寸侧边栏。" },
	    	{name : "ui-sidebar-lg",el :"大尺寸侧边栏。" },
	    	{name : "ui-sidebar-mask",el :"侧边栏的模态层。" },
	    ];

    }

}



// WEBPACK FOOTER //
// ./src/app/view/sidebar/sidebar.component.ts